const hasSms2faError = (errors: DeserializeError) =>
  errors?.otp?.includes('SMS_2FA_IS_REQUIRED') ||
  errors?.otp?.includes('SMS_2FA_VERIFICATION_FAILED');

export default hasSms2faError;
